import { Box, Tooltip, Typography } from "@mui/material";
import { APP_DEVELOPER, APP_VERSION } from "@web/config/app-info";

export function SidebarFooter({ collapsed = false }: { collapsed?: boolean }) {
  return (
    <Tooltip
      title={
        collapsed
          ? `Version ${APP_VERSION} · Developed by ${APP_DEVELOPER}`
          : ""
      }
      placement="right"
    >
      <Box
        component="footer"
        aria-label={`Version ${APP_VERSION}. Developed by ${APP_DEVELOPER}`}
        tabIndex={collapsed ? 0 : undefined}
        sx={{
          flexShrink: 0,
          px: collapsed ? 0.5 : 2.25,
          pt: 1.5,
          pb: "max(16px, env(safe-area-inset-bottom))",
          borderTop: "1px solid rgba(255,255,255,0.12)",
          color: "#B8C5DB",
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: 11, fontWeight: 600 }}>
          {collapsed ? `v${APP_VERSION}` : `Version ${APP_VERSION}`}
        </Typography>
        {!collapsed && (
          <>
            <Typography
              sx={{
                fontSize: 10,
                mt: 1,
                color: "var(--orbit-ink-8392ac, #8392AC)",
              }}
            >
              Developed by
            </Typography>
            <Box
              component="img"
              src="/branding/srmi-logo.png"
              alt={APP_DEVELOPER}
              sx={{
                display: "block",
                width: "100%",
                maxWidth: 144,
                height: "auto",
                mt: 0.75,
                mx: "auto",
              }}
            />
          </>
        )}
      </Box>
    </Tooltip>
  );
}
